import { outflowManyOffers } from 'reactApp/appHelpers/featuresHelpers/features/outflowManyOffers';
import type { BillingDataSubscriptionInfo } from 'reactApp/modules/billingData/billingData.types';
import { manyOffers } from 'reactApp/modules/subscriptionRenewal/outflowOffers/manyOffers';
import type { OutflowOfferWebProps } from 'reactApp/modules/subscriptionRenewal/outflowOffers/offers.types';
import { cancelAutoRenewOffer } from 'reactApp/modules/subscriptionRenewal/outflowOffers/offers/cancelAutoRenew.offer';
import { captchaWeb } from 'reactApp/modules/subscriptionRenewal/outflowOffers/offers/captcha.offer';
import { captchaAndSurvey } from 'reactApp/modules/subscriptionRenewal/outflowOffers/offers/captchaAndSurvey';
import { checkDiscountOffer, discountOffer } from 'reactApp/modules/subscriptionRenewal/outflowOffers/offers/discount.offer';
import { checkFamilyOffer, familyOffer } from 'reactApp/modules/subscriptionRenewal/outflowOffers/offers/family.offer';
import { checkPauseOffer, pauseOffer } from 'reactApp/modules/subscriptionRenewal/outflowOffers/offers/pause.offer';
import { surveyOffer } from 'reactApp/modules/subscriptionRenewal/outflowOffers/offers/survey.offer';
import {
    checkUnlimitedAutoUploadOffer,
    unlimitedAutoUploadOffer,
} from 'reactApp/modules/subscriptionRenewal/outflowOffers/offers/unlimitedAutoUpload.offer';
import { checkVkMusicOffer, vkMusicOffer } from 'reactApp/modules/subscriptionRenewal/outflowOffers/offers/vkMusic.offer';
import { createOfferProcessor } from 'reactApp/modules/subscriptionRenewal/outflowOffers/subscriptionRenewal.offers';
import { isVkMusicSubscription } from 'reactApp/sections/SubscriptionsPage/SubscriptionsPage.helpers';

import { OutflowOffers } from './offers.types';

/**
 * @description Регистрация порядка показа предложений при отписке для веб версии
 *
 * @param subscription - подписка
 * @returns массив указывающий какие оферы и в каком порядке будут показаны
 */
export function getWebOutflowOffers(subscription: BillingDataSubscriptionInfo) {
    if (isVkMusicSubscription(subscription)) {
        return [
            OutflowOffers.ARE_YOU_SURE,
            OutflowOffers.SURVEY,
            OutflowOffers.VK_MUSIC,
            OutflowOffers.UNLIMITED_AUTOUPLOAD,
            OutflowOffers.CAPTCHA,
        ];
    }

    if (outflowManyOffers.enabled) {
        return manyOffers();
    }

    return [
        OutflowOffers.UNLIMITED_AUTOUPLOAD,
        OutflowOffers.ARE_YOU_SURE,
        OutflowOffers.FAMILY,
        OutflowOffers.PAUSE,
        OutflowOffers.DISCOUNT,
        OutflowOffers.CAPTCHA_WITH_SURVEY,
    ];
}

/**
 * Регистрация предложений для показа
 * @param offer - функция показывающая оффер
 * @param check - функция определяющая доступность показа оффера
 */
export const { processOuflowOfferList: processWebOuflowOfferList } = createOfferProcessor<OutflowOfferWebProps>({
    [OutflowOffers.VK_MUSIC]: {
        check: checkVkMusicOffer,
        offer: vkMusicOffer,
    },
    [OutflowOffers.ARE_YOU_SURE]: {
        offer: cancelAutoRenewOffer,
    },
    [OutflowOffers.FAMILY]: {
        check: checkFamilyOffer,
        offer: familyOffer,
    },
    [OutflowOffers.UNLIMITED_AUTOUPLOAD]: {
        check: checkUnlimitedAutoUploadOffer,
        offer: unlimitedAutoUploadOffer,
    },
    [OutflowOffers.DISCOUNT]: {
        check: checkDiscountOffer,
        offer: discountOffer,
    },
    [OutflowOffers.PAUSE]: {
        check: checkPauseOffer,
        offer: pauseOffer,
    },
    [OutflowOffers.CAPTCHA_WITH_SURVEY]: {
        offer: captchaAndSurvey,
    },
    [OutflowOffers.CAPTCHA]: {
        offer: captchaWeb,
    },
    [OutflowOffers.SURVEY]: {
        offer: surveyOffer,
    },
});
